import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { SxProps } from '@mui/material';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';

type Props = {
  sx?: SxProps;
};

export const WhiteIpAddressesTooltip: React.FC<Props> = ({ sx }) => {
  return (
    <Tooltip
      arrow
      placement="right"
      title={
        <Typography fontSize={12}>
          Маска определяет, с каких IP-адресов Kubera примет запросы:
          <ul>
            <li>&#34;пусто&#34; или &#34;32&#34; - только точный IP-адрес.</li>
            <li> &#34;0&#34; - любой IP-адрес (не рекомендуется).</li>
            <li>&#34;Другие значения&#34; - диапазон разрешенных IP-адресов по маске.</li>
          </ul>
        </Typography>
      }
    >
      <InfoOutlinedIcon color="secondary" sx={{ ...sx, width: '17px', height: '17px' }} />
    </Tooltip>
  );
};
